import React, { useMemo } from 'react';
import { Col, Divider, Card, Layout, Row, Typography, Table } from 'antd';
import Plot from '../../../../node_modules/react-plotly.js/react-plotly';
import { stringMixin } from "../../../utils/strings";
import { Scatter } from '@ant-design/plots';
import { useScreenWidth } from "../../../hooks/useScreen";
import { useAntCharts } from "../../../modules/Charts/Ant/useAntCharts";
import Explainer from "../../../components/Explainer";





const LoadingMatrix = ({ data }) => {
  // Convert loading matrix to data suitable for table and scatter plot
  const loadingMatrix = data.loading_matrix;
  const { axisConfig } = useAntCharts();
  const tableData = [];
  const scatterData = [];

  // Define initial columns where each component will be a single column
  const columns = [
    {
      title: 'Ticker',
      dataIndex: 'ticker',
      key: 'ticker',
    },
  ];

  // Now add each component as a column exactly once
  Object.keys(loadingMatrix).forEach((component) => {
    columns.push({
      title: 'C (' + component.split('_')[1] + ')',
      dataIndex: component,
      key: component,
      render: (value) => {
        // Add conditional color styling for values
        const backgroundColor = value > 0 ? '#cdffff' : '#ffcdeb'; // light green for positive, light red for negative
        return {
          children: stringMixin.pct(value),
          props: {
            style: {
              backgroundColor,
            },
          },
        };
      },
    });
  });

  // Now build tableData where each row is a ticker and each column is a component
  Object.keys(loadingMatrix[Object.keys(loadingMatrix)[0]]).forEach((ticker, index) => {
    const tickerData = { key: index, ticker }; // Each row corresponds to a ticker

    // Populate each component's value for the row (ticker)
    Object.keys(loadingMatrix).forEach((component) => {
      const value = loadingMatrix[component][ticker];
      tickerData[component] = value;

      // Push data into scatterData array for the scatter chart
      scatterData.push({
        component: 'C (' + component.split('_')[1] + ')',
        ticker,
        value: Math.abs(value),
        sign: value > 0 ? 'positive' : 'negative',
      });
    });

    tableData.push(tickerData);
  });

  // Scatter chart config where x-axis is components and y-axis is tickers
  const scatterConfig = {
    data: scatterData,
    xField: 'component',
    yField: 'ticker',
    sizeField: 'value',
    colorField: 'sign',
    shapeField: 'point',
    xAxis: {
      title: {
        text: 'Components',
      },
    },
    yAxis: {
      title: {
        text: 'Tickers',
      },
    },
    tooltip: {
      fields: ['component', 'ticker', 'value'],
      showTitle: false,
    },
    scale: { color: { palette: ['#009bff', '#1D2024'] } },
    axis: {
      x: { ...axisConfig },
      y: { ...axisConfig },
    },
    legend: {},
  };

  return (
    <>
      <Card bordered={false} title={<Typography.Title>Advanced Analysis</Typography.Title>}>
        <Typography.Paragraph>
          More detailed breakdown inside the contributions of each ticker and factor used in the model
        </Typography.Paragraph>
      </Card>
      <Divider/>
      <Row justify={'center'} gutter={[32, 32]}  style={{ display: 'flex', alignItems: 'stretch' }}>
        <Col xs={24} xl={12} style={{ display: 'flex', flexDirection: 'column' }}>
          <Card bordered={false} title={  <Explainer title={'Loading Contributions'}/>}
                style={{flexGrow: 1}}
          >
            <Table
              dataSource={tableData}
              columns={columns}
              pagination={false}
              scroll={{ y: 600 }}
              size={'small'}
            />
          </Card>
        </Col>
        <Col xs={24} xl={12} style={{ display: 'flex', flexDirection: 'column' }}>
          <Card bordered={false} style={{ flexGrow: 1 }}
                title={<Explainer title={'Loading Contributions'} />}
          >
            <div style={{ height: 650, width: '100%' }}>
              <Scatter {...scatterConfig} />
            </div>
          </Card>
        </Col>
        {/* Needs to be square so set fixed width */}
      </Row>
    </>
  );
};

export default LoadingMatrix;


